var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10mm",
    height: "10mm",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.324 -57.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.197,
    y: 57.819,
    width: 7.8263,
    height: 8.0025,
    fill: "#ae8514",
    fillOpacity: 0.88519,
    strokeWidth: 0.32876
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.824 57.67 3.5 3.5v2l-3.5 3.5-0.5-0.5v-8z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.824 57.67-3.5 3.5h-2l-3.5-3.5 0.5-0.5h8z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.824 66.67-3.5-1.5v-4l3.5-3.5 0.5 0.5v8z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.824 66.67 3.5-3.5h2l3.5 3.5-0.5 0.5h-8z",
    fill: "#4d4d4d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.6037a15c26ded5484ae34210a1816014.svg";
export { ForwardRef as ReactComponent };